export const deClientPortalErrorPagePages = {
    errorPage: {
        status: {
            unauthorized: {
                title: '401 Zugriff verweigert',
                message:
                    'Ihr Zugriff wurde verweigert. Bitte versuchen Sie, sich abzumelden und erneut anzumelden oder die Seite zu aktualisieren. Falls das Problem weiterhin besteht, wenden Sie sich bitte an den Support.',
            },
            forbidden: {
                title: '403 Zugriff verweigert',
                message: 'Sie haben keine Zugriffsberechtigung. Wenden Sie sich ggf. an den Support.',
            },
            notFound: {
                title: '404 Seite nicht gefunden',
                message: 'Entschuldigung, hier ist wohl etwas schief gelaufen. Die gewünschte Seite kann nicht gefunden werden.',
            },
            default: {
                title: 'Ups...',
                message: 'Entschuldigung, ein unerwarteter Fehler ist aufgetreten.',
            },
        },
        emptyState: {
            title: 'Willkommen bei einwert',
            assets: 'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder wir haben Ihr erstes Gutachten noch nicht abgeschlossen.',
            analysis:
                'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder Ihr erstes Gutachten ist noch nicht abgeschlossen – erst dann können Sie hier Ihre Immobilien vergleichen.',
            default:
                'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder Ihr erstes Gutachten ist noch nicht abgeschlossen – erst dann sehen Sie hier Ihre Übersicht.',
        },
        actions: {
            orders: 'Bewertungsaufträge',
            signOut: 'Abmelden',
            back: 'Zurück',
            overview: 'Übersicht',
        },
        supportHint: 'Sollte der Fehler weiterhin bestehen, wenden Sie sich an',
    },
    welcomePage: {
        title: 'Willkommen bei einwert',
        message: 'Bevor Sie starten, vervollständigen Sie bitte Ihr Nutzerprofil, indem Sie auf den nachfolgenden Button klicken.',
        profile: 'Zum Profil',
    },
}
